module.exports = __webpack_public_path__ + "static/media/Dawn_transparent.c3f347b5.webp";